import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Fab,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog
} from '@material-ui/core';
import {
  Add,
  Edit,
  Delete,
  Image
} from '@material-ui/icons';
import PerfectScrollbar from 'react-perfect-scrollbar';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Partenaire extends React.Component {
  constructor() {
    super();
    this.state = {
      partenaire: [],
      name: "",
      description: "",
      liens_logo: "",
      liens_site: "",
      isLogged: true,
      redirect: false,
      newModalOpen: false,
      deleteModalOpen: false,
      deleteId: "",
      modifedId: "",
      snackbarMessage: "",
      snackbarOpen: false,
      sidebarOpen: false,
      putModalOpen: false,
      redirectLogOut: false,
      limit: false,
      selectFileImages: null,
      loaded1: false
    }
  }

  handleChangeInput = (event) => {
    switch (event.target.name) {
      case 'name':
        this.setState({ name: event.target.value })
        break;
      case 'description':
        this.setState({ description: event.target.value })
        break;
      case 'liens_logo':
        this.setState({ liens_logo: event.target.value })
        break;
      case 'liens_site':
        this.setState({ liens_site: event.target.value })
        break;
      default:
        break;
    }
  }

  deleteBureau = () => {
    this.handleCloseDeleteModal();
    const partenaire_id = this.state.partenaire[this.state.deleteId].id
    fetch(SERVER_ADDRESS + '/partenaires/' + partenaire_id,
      {
        method: 'DELETE',
        headers: new Headers({
          'authorization': 'Bearer ' + localStorage.getItem('token')
        })
      }
    )
      .then(() => { this.getData() })
      .then(
        (res) => {
          this.setState({
            snackbarOpen: true,
            snackbarMessage: "Partenaire supprimé"
          })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  addBureau = () => {
    this.handleCloseNewModal();
    this.onClickHandler();
    let partenaire = {
      name: this.state.name,
      description: this.state.description,
      liens_logo: this.state.liens_logo,
      liens_site: this.state.liens_site
    }
    fetch(SERVER_ADDRESS + '/partenaires',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(partenaire),
      })
      .then(res => {
        res.json()
        console.log(res)
      })
      .then(() => { this.getData() })
      .then(res => this.setState({ snackbarMessage: "Partenaire ajouté." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  putBureau = () => {
    this.handleClosePutModal();
    this.onClickHandler();
    let partenaire = {
      name: this.state.name,
      description: this.state.description,
      liens_logo: this.state.liens_logo,
      liens_site: this.state.liens_site
    }
    let partenaire_id = this.state.partenaire[this.state.modifedId].id
    console.log(partenaire_id)
    fetch(SERVER_ADDRESS + '/partenaires/' + partenaire_id,
      {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(partenaire),
      })
      .then(
        () => {
          fetch(SERVER_ADDRESS + '/partenaires',
            {
              headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('token')
              }),

            }
          )
            .then(res => res.json())
            .then(res => this.setState({ partenaire: res }))
            .then(
              () => console.log(this.state.partenaire)
            )
        }
      )
      .then(res => this.setState({ snackbarMessage: "Partenaire modifié." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
      .then(
        () => {
          const newArrayBureau = this.state.partenaire
          newArrayBureau[this.state.modifedId] = {
            id: partenaire_id,
            email: this.state.email
          }
          this.setState({ partenaire: newArrayBureau })
        }
      )
  }

  handleClosePutModal = () => {
    this.setState({ putModalOpen: false })
  }

  handleOpenPutModal = (index) => {
    let user_id = this.state.partenaire[index].id
    fetch(SERVER_ADDRESS + '/partenaires/' + user_id)
      .then(res => res.json())
      .then(res => {
        this.setState({
          name: res[0].name,
          description: res[0].description,
          liens_logo: res[0].liens_logo,
          liens_site: res[0].liens_site
        }, () => {
          this.setState({ putModalOpen: true })
          this.setState({ modifedId: index })
        })
      })
  }

  handleCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false })
  }

  handleOpenDeleteModal = (index) => {
    this.setState({ deleteModalOpen: true })
    this.setState({ deleteId: index })
  }

  handleOpenNewModal = () => {
    this.setState({
      name: "",
      description: "",
      liens_logo: "",
      liens_site: ""
    }, () => {
      this.setState({ newModalOpen: true })
    })
  }

  handleCloseNewModal = () => {
    this.setState({ newModalOpen: false })
  }

  openMenu = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen })
    const menu = document.querySelector('.side-nav')
    if (this.state.sidebarOpen === false) {
      menu.style.display = "block"
    }
    else {
      menu.style.display = "none"
    }
  }

  getData = () => {
    fetch(SERVER_ADDRESS + '/partenaires',
      {
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),

      }
    )
      .then(res => res.json())
      .then((res) => {
        this.setState({ partenaire: res })
      })

  }

  componentDidMount() {
    const token = {
      token: localStorage.getItem('token')
    }

    fetch(SERVER_ADDRESS + '/token',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(token),
      })
      .then(res => res.json())
      .then(
        (res) => {
          this.setState(
            {
              isLogged: res.succes,
              redirect: res.succes ? false : true
            });
        }
      )
    this.getData()
  }

  logOut = () => {
    this.setState({ redirectLogOut: true })
    localStorage.setItem('token', "")
  }

  onClickHandler = () => {
    const data = new FormData();
    data.append("file", this.state.selectFileImages);
    fetch(SERVER_ADDRESS + '/uploadFile', {
      method: 'POST',
      mode: "cors",
      credentials: "same-origin",
      redirect: "follow",
      referrer: "no-referrer",
      body: data
    }).then(res => {
      console.log(res.statusText);
    });
  };

  onChangeHandler = event => {
    this.setState({
      selectFileImages: event.target.files[0],
      loaded1: true,
    }, () => this.setState({ liens_logo: this.state.selectFileImages.name }));
  }

  render() {
    return (
      <>
        <Grid className="item" item>
          <Paper elevation={1}>
            <Card>
              <CardHeader
                className="jtestd"
                action={
                  <Fab
                    style={{ backgroundColor: "#1976d2", color: 'white' }}
                    onClick={this.handleOpenNewModal}
                    size="small"
                  >
                    <Add />
                  </Fab>
                }
                title="Nos partenaires"
              />
              <Divider />
              <CardContent className="content">
                <PerfectScrollbar>
                  <div className="inner">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Nom</TableCell>
                          <TableCell>Description</TableCell>
                          <TableCell>Liens du logo</TableCell>
                          <TableCell>Liens du site_web</TableCell>
                          <TableCell>Editer / Supprimer</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.partenaire.map((partenaires, index) => (
                          <TableRow
                            hover
                            key={partenaires.id}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{partenaires.name}</TableCell>
                            <TableCell>{partenaires.description}</TableCell>
                            <TableCell>{partenaires.liens_logo}</TableCell>
                            <TableCell>{partenaires.liens_site}</TableCell>
                            <TableCell>

                              <Button
                                style={{ backgroundColor: "#1976d2", color: 'white' }}
                                onClick={() => this.handleOpenPutModal(index)}
                                size="small"
                                startIcon={<Edit />}
                              >
                                Editer
                          </Button>
                              <Button
                                style={{ marginLeft: '10px' }}
                                disabled={this.state.limit}
                                variant="contained"
                                onClick={() => this.handleOpenDeleteModal(index)}
                                color="secondary"
                                size="small"
                                endIcon={<Delete />}
                              >
                                Supprimer
                          </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </PerfectScrollbar>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
        <Dialog open={this.state.newModalOpen} onClose={this.handleCloseNewModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Crée un partenaire</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour créer un partenaire veuillez remplir les champs obligatoires.
                  </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="name"
              type="text"
              fullWidth
              name="name"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="description"
              label="Description"
              type="text"
              fullWidth
              multiline
              name="description"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="liens_site"
              label="Liens vers le site web"
              type="text"
              fullWidth
              name="liens_site"
              onChange={this.handleChangeInput}
            />
            <input
              style={{
                display: "none"
              }}
              accept="image/*"
              id="contained-button-file"
              multiple
              type="file"
              onChange={this.onChangeHandler}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                endIcon={<Image />}
              >
                Choisir une image
              </Button>
              {this.state.loaded1 ? this.state.selectFileImages.name : ""}
            </label>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseNewModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.addBureau} color="primary">
              Créer
                  </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.deleteModalOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Suppression d'un partenaire"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Etes vous sur de vouloir supprimer le partenaire ?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDeleteModal} color="primary">
              Non
              </Button>
            <Button onClick={this.deleteBureau} color="primary" autoFocus>
              Oui
              </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.putModalOpen} onClose={this.handleClosePutModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Modifier un partenaire</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour modifer ce partenaire veuillez saisir les champs obligatoires.
                </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="name"
              type="text"
              fullWidth
              name="name"
              onChange={this.handleChangeInput}
              defaultValue={this.state.name}
            />
            <TextField
              margin="dense"
              id="description"
              label="Description"
              type="text"
              fullWidth
              multiline
              name="description"
              onChange={this.handleChangeInput}
              defaultValue={this.state.description}
            />
            <TextField
              margin="dense"
              id="liens_site"
              label="Liens vers le site web"
              type="text"
              fullWidth
              name="liens_site"
              onChange={this.handleChangeInput}
              defaultValue={this.state.liens_site}
            />
            <input
              style={{
                display: "none"
              }}
              accept="image/*"
              id="contained-button-file"
              multiple
              type="file"
              onChange={this.onChangeHandler}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                endIcon={<Image />}
              >
                Choisir une image
              </Button>
              {this.state.loaded1 ? this.state.selectFileImages.name : ""}
            </label>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePutModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.putBureau} color="primary">
              Modifier
                  </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
        />

      </>
    );
  }
}

export default Partenaire;
